// import React, { useState, useContext, useEffect, useRef } from "react";
// import "../../../../Users/homepage.css";
// import "../../../../Users/pages/innercss.css";
// import { Form, Link, redirect } from "react-router-dom";
// import { useParams } from 'react-router-dom'
// import { apiurl } from "../../../../../path";
// import UserApplication from "../../../../Users/UserContext/UserContext";
// import { Bank32, barely_black_bg_img, Cancel32, Email32, Location32, PhoneNumber32, submit } from "../../../../../public/LoginImages/importimages";
// import { useLanguage } from "../../../../../lang/langcontext/LanguageContext";

// const CreateContractor = () => {
//       const { language, toggleLanguage, t } = useLanguage();
//     let data = useContext(UserApplication)
//     const { SetNotification, paymentdata, GetAuctionsList, TenderRegisterHash, TenderPayment, DownloadReciept, setpaymentdata } = data
//     const [form, setform] = useState([])
//     const [Auction, SetAuction] = useState([])
//     const { Auction_ID, Auction_Name } = useParams()
//     const [loading, setLoading] = useState(false);

//     const [forminf, SetForminf] = useState({ Bidder_CompanyName: "", Address: "", City: "", PinCode: "", GST_No: "", PAN_No: "", TAN_No: "", AadharNo: "", Mobile_No: "", Email: "", Tender_ID: "", Tender_Name: "", TenderFee: "", ErnestMoneyDeposit: "", GST: "", Account_Number: "", IFSC_CODE: "", BANK_NAME: "", MICRNo: "", BranchName: "" });

//     // console.log(forminf.IFSC_CODE);
//     const [formErrors, setFormErrors] = useState({ Bidder_CompanyName: "", Address: "", City: "", PinCode: "", GST_No: "", PAN_No: "", TAN_No: "", AadharNo: "", Mobile_No: "", Email: "", Tender_ID: "", Tender_Name: "", TenderFee: "", ErnestMoneyDeposit: "", GST: "", Account_Number: "", IFSC_CODE: "", BANK_NAME: "", MICRNo: "", BranchName: "" });

//     const [recieptview, showrecieptview] = useState(true)
//     const [isGSTValid, setIsGSTValid] = useState(null);
//     const [isPANValid, setIsPANValid] = useState(null);
//     const [isTANValid, setIsTANValid] = useState(null);
//     const [accountnum, setaccountnum] = useState(null);

//     const [isIfscValid, setIsIfscValid] = useState(null);
//     const formdataref = useRef(null)
//     const validateIfsc = async () => {
//         let IFSC_CODE = document.getElementById('IFSC_CODE').value.toUpperCase();
//         try {
//             const response = await fetch(`https://ifsc.razorpay.com/${IFSC_CODE}`);
//             if (response.ok) {
//                 setIsIfscValid(true);
//             } else {
//                 setIsIfscValid(false);
//             }
//         } catch (error) {
//             setIsIfscValid(false);
//             console.error("Error validating IFSC code:", error);
//         }
//     };

//     // const checkGSTandPAN = (id, value) => {
//     //     const gstRegex = /^([0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1})$/;
//     //     const panRegex = /^([A-Z]{5}[0-9]{4}[A-Z]{1})$/;

//     //     if (id === "GST_No") {
//     //         setIsGSTValid(value.trim() === "" ? null : gstRegex.test(value));
//     //     }

//     //     if (id === "PAN_No") {
//     //         setIsPANValid(value.trim() === "" ? null : panRegex.test(value));
//     //     }
//     //     if (id === "TAN_No") {
//     //         setIsTANValid(value.trim() === "" ? null : panRegex.test(value));
//     //     }
//     // };

//     const checkGSTandPAN = (id, inputValue) => {

//         const gstRegex = /^([0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1})$/;
//         const panRegex = /^([A-Z]{5}[0-9]{4}[A-Z]{1})$/;

//         let PAN_Number = document.getElementById('PAN_No')?.value.toUpperCase();
//         let Gst_Number = document.getElementById('GST_No')?.value.toUpperCase();
//         console.log("checkGSTandPAN called:", { id, inputValue, PAN_Number, Gst_Number });

//         if (id === "PAN_No") {
//             setIsPANValid(inputValue.trim() === "" ? null : panRegex.test(inputValue));
//         }

//         if (id === "GST_No") {

//             if (!gstRegex.test(inputValue)) {
//                 return setIsGSTValid(false);
//             }

//             if (!PAN_Number || !panRegex.test(PAN_Number)) {
//                 return setIsGSTValid(false);
//             }

//             const panInGST = Gst_Number.slice(2, 12);

//             if (panInGST !== PAN_Number) {
//                 return setIsGSTValid(false);
//             }

//             else {
//                 setIsGSTValid(true);
//             }

//         }

//     };

//     useEffect(() => {
//         try {
//             setpaymentdata(null)
//             // getdata()
//         } catch (error) {
//             console.error('Error in useEffect:', error);
//             throw error;
//         }
//     }, [])

//     const setdata = (e) => {
//         try {
//             let check = document.getElementById("checkacnumber").value;
//             let acnum = document.getElementById("Account_Number").value;
//             if (check === "" || acnum === "") {
//                 setaccountnum(null);
//             } else {
//                 setaccountnum(check === acnum ? true : false);
//             }
//             // setaccountnum(check === acnum && check !== "" && acnum !== "" ? true : false);

//             const { id, value } = e.target;
//             let finalValue = value;
//             let errorMessage = "";
//             const validUserName = /^[a-zA-Z0-9 ]*$/;
//             const validPinCode = /^[0-9]{6}$/;
//             const validMobile = /^[0-9]{10}$/;
//             const validEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//             const validAccountNumber = /^[0-9]{6,18}$/;
//             if ((id === "Bidder_CompanyName" || id === "Address" || id === "City" || id === "BANK_NAME" || id === "Account_HolderName" || id === "BranchName") && !validUserName.test(value)) {
//                 errorMessage = "Only alphanumeric characters and spaces are allowed.";
//             }
//             if (id === "PinCode") {
//                 if (value === "") {
//                     errorMessage = "";
//                 } else if (!validPinCode.test(value)) {
//                     errorMessage = "Pin code must be exactly 6 digits.";
//                 } else {
//                     errorMessage = "";
//                 }
//             }
//             // Ensure IFSC_CODE is always uppercase
//             if (id === "IFSC_CODE") {
//                 finalValue = value.toUpperCase();
//             }
//             if (id === "MobileNumber" && !validMobile.test(value)) {
//                 errorMessage = "Mobile number must be exactly 10 digits.";
//             }
//             if (id === "Email") {
//                 if (value === "") {
//                     errorMessage = "";
//                 } else if (!validEmail.test(value)) {
//                     errorMessage = "Invalid email format. Example: abc@example.com.";
//                 } else {
//                     errorMessage = "";
//                 }
//             }

//             if (id === "checkacnumber" && !validAccountNumber.test(value)) {
//                 errorMessage = "Account number must be 6 to 18 digits.";
//             }
//             // Update form state
//             SetForminf((prev) => ({ ...prev, [id]: finalValue }));
//             setFormErrors((prev) => ({ ...prev, [id]: errorMessage }));
//             // Perform validation only for GST_No and PAN_No
//             if (id === "GST_No" || id === "PAN_No") {
//                 checkGSTandPAN(id, finalValue);
//             }
//         } catch (error) {
//             console.error('Error in onSubmit:', error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     var upload = new FormData();

//     const onSubmit = async (e) => {
//         e.preventDefault()
//         setLoading(true);
//         let token = localStorage.getItem("Token");
//         try {
//             for (const key in forminf) {
//                 upload.append(key, forminf[key]);
//             }
//             let PassbookDoc = document.getElementById("PassbookDoc").files;
//             upload.append("PassbookDoc", PassbookDoc[0]);
//             let ChequeDoc = document.getElementById("ChequeDoc").files;
//             upload.append("ChequeDoc", ChequeDoc[0]);
//             let PanDoc = document.getElementById("PanDoc").files;
//             upload.append("PanDoc", PanDoc[0]);
//             let TanDoc = document.getElementById("TanDoc").files;
//             upload.append("TanDoc", TanDoc[0]);
//             let GstDoc = document.getElementById("GstDoc").files;
//             upload.append("GstDoc", GstDoc[0]);
//             let AadharDoc = document.getElementById("AadharDoc").files;
//             upload.append("AadharDoc", AadharDoc[0]);

//             console.log("upload", upload);
//             const response = await fetch(`${apiurl}/VendorManagement/ContractorRegistration`, {
//                 method: 'POST',
//                 headers: { AuthToken: token },
//                 body: upload,
//             });
//             const data = await response.json();
//             console.log(data)
//             if (data.message) {
//                 alert(data.message)
//                 window.location.reload();
//             }
//         } catch (error) {
//             console.error('Error in onSubmit:', error);
//             throw error;
//         }
//     }
//     const resetData = () => {
//         formdataref.current.reset()
//         SetForminf([])
//     }

//  return (
//         <>
//             <div style={{ maxHeight: '91vh', overflowY: 'auto' }}>
//                 <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '2.5rem', backgroundColor: '#ece9fe' }}>
//                     <h5 style={{ textAlign: "center" }}><b>{t("Vendor Registration")}</b></h5></div>
//                 <div style={{ backgroundColor: '#f4f7fe', backgroundSize: 'cover', width: '82vw', alignSelf: 'center', display: 'grid', justifyContent: "center", padding: '1rem', position: "relative", backdropFilter: 'blur(10px)', }}>

//                     <div style={{ display: "grid", justifyContent: "center" }}>
//                         <div className="card-body my-3" style={{ width: "75vw" }}>
//                             {loading && (
//                                 <div
//                                     style={{
//                                         position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(4px)', zIndex: 9999,
//                                         display: 'flex', justifyContent: 'center', alignItems: 'center'
//                                     }}>
//                                     <div style={{ border: '6px solid #f3f3f3', borderTop: '6px solid #007bff', borderRadius: '50%', width: '60px', height: '60px', animation: 'spin 1s linear infinite' }} />
//                                     <style>
//                                         {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
//                                     </style>
//                                 </div>
//                             )}
//                             <Form id='form1' ref={formdataref} onSubmit={(e) => { isPANValid === true && accountnum === true && isIfscValid === true ? onSubmit(e) : alert('incorrect details') }} style={{ backgroundColor: 'rgb(255,255,255,0.8)', borderRadius: '20px 20px 0px 0px' }} >
//                                 <div className="mx-5" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}><h5 style={{ background: 'linear-gradient(to bottom, #3b409e, #0067ab, #0f79ba, #0098d5)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontWeight: '700', margin: '0px' }}><b>{t("Personal Details")}</b></h5></div>
//                                 <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
//                                     <div style={{ backgroundColor: '#f4f7fe', borderRadius: '20px', paddingBottom: '15px' }}>
//                                         <div className="bidder_register_form">
//                                             <div className="mx-3 my-1" style={{ width: "29rem" }}>
//                                                 <label>{t("Vendor Name :")}</label>
//                                                 <input type="text" id="Bidder_CompanyName" placeholder={t("Enter Vendor Name")} className="form-control" required onChange={(e) => { setdata(e) }} /> {formErrors.Bidder_CompanyName && (
//                                                     <small style={{ color: "red", fontWeight: "bold" }}>
//                                                         {formErrors.Bidder_CompanyName}
//                                                     </small>
//                                                 )}
//                                             </div>
//                                             <div className="mx-3 my-1" style={{ width: "29rem" }}>
//                                                 <label>{t("Address :")}</label>
//                                                 <div style={{ position: 'relative' }}>
//                                                     <input type="text" id="Address" placeholder={t("Enter Address")} className="form-control" required onChange={(e) => { setdata(e) }} />
//                                                     <img src={Location32} alt="Email Icon" style={{
//                                                         position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", width: "20px",
//                                                         height: "20px"
//                                                     }} />
//                                                 </div>
//                                                 {formErrors.Address && (
//                                                     <small style={{ color: "red", fontWeight: "bold" }}>
//                                                         {formErrors.Address}
//                                                     </small>
//                                                 )}
//                                             </div>
//                                         </div>
//                                         <div className="bidder_register_form">
//                                             <div className="mx-3 my-1" style={{ width: "29rem" }}>
//                                                 <label>{t("Mobile No :")}</label>
//                                                 <div style={{ position: "relative" }}>
//                                                     <input type="text" className="form-control" id="Mobile_No" pattern="\d{10}" minLength="10" maxLength="10" placeholder={t("Enter Mobile No")}
//                                                         onInput={(e) => { let enteredValue = e.target.value; enteredValue = enteredValue.slice(0, 10).replace(/\D/g, ''); e.target.value = enteredValue; }} onChange={(e) => { setdata(e) }} required />
//                                                     <img src={PhoneNumber32} alt="Email Icon" style={{
//                                                         position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", width: "20px",
//                                                         height: "20px"
//                                                     }} />
//                                                 </div>
//                                                 {formErrors.MobileNumber && (<small style={{ color: "red", fontWeight: "bold" }}>{formErrors.MobileNumber}</small>)}
//                                             </div>
//                                             <div className="mx-3 my-1" style={{ width: "29rem", position: "relative" }}>
//                                                 <label>{t("Email :")}</label>
//                                                 <div style={{ position: "relative" }}>
//                                                     <input type="email" id="Email" placeholder={t("Enter Email")} className="form-control pe-5" required onChange={(e) => setdata(e)} />
//                                                     <img src={Email32} alt="Email Icon" style={{
//                                                         position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", width: "20px",
//                                                         height: "20px"
//                                                     }} />
//                                                 </div>
//                                                 {formErrors.Email && (
//                                                     <small style={{ color: "red", fontWeight: "bold" }}>
//                                                         {formErrors.Email}
//                                                     </small>
//                                                 )}
//                                             </div>

//                                         </div>
//                                         <div className="bidder_register_form">

//                                             <div className="mx-3 my-1" style={{ width: "29rem" }}>
//                                                 <label>{t("Pin Code :")}</label>
//                                                 <input type="tel" id="PinCode" pattern="\d{6}" minLength="6" maxLength="6" placeholder={t("Enter Pin Code")} className="form-control"
//                                                     onInput={(e) => {
//                                                         let enteredValue = e.target.value;
//                                                         enteredValue = enteredValue.slice(0, 6).replace(/\D/g, '');
//                                                         e.target.value = enteredValue;
//                                                     }}
//                                                     onChange={(e) => { setdata(e) }}
//                                                     required
//                                                 /> {formErrors.PinCode && (<small style={{ color: "red", fontWeight: "bold" }}>{formErrors.PinCode}</small>)}
//                                             </div>
//                                             <div className="mx-3 my-1" style={{ width: "29rem" }}>
//                                                 <label>{t("City :")}</label>
//                                                 <input type="text" id="City" placeholder={t("Enter City")} className="form-control" required onChange={(e) => { setdata(e) }} />
//                                                 {formErrors.City && (<small style={{ color: "red", fontWeight: "bold" }}>{formErrors.City}</small>)}
//                                             </div>
//                                         </div>
//                                         <div className="bidder_register_form">
//                                             <div className="mx-3 my-1" style={{ width: "29rem" }}>
//                                                 <label>{t("PAN Number :")}</label>
//                                                 <input type="text" id="PAN_No" placeholder={t("Enter PAN No.")} className="form-control" required onChange={(e) => { setdata(e); checkGSTandPAN() }} style={{}} value={forminf.PAN_No || ""} minLength={10} maxLength={10} />
//                                                 {isPANValid === false && <b style={{ color: "red" }}>{t("Invalid PAN")}</b>}
//                                                 {isPANValid === true && <b style={{ color: "green" }}>{t("Valid")}</b>}
//                                             </div>
//                                             <div className="mx-3 my-1" style={{ width: "29rem" }}>
//                                                 <label>{t("TAN Number :")}</label>
//                                                 <input type="text" id="TAN_No" placeholder={t("Enter TAN No.")} className="form-control" required onChange={(e) => { setdata(e); checkGSTandPAN() }} style={{}} value={forminf.TAN_No || ""} minLength={10} maxLength={10} />
//                                                 {isTANValid === false && <b style={{ color: "red" }}>{t("Invalid TAN")}</b>}
//                                                 {isTANValid === true && <b style={{ color: "green" }}>{t("Valid")}</b>}
//                                             </div>
//                                         </div>

//                                         <div className="bidder_register_form">
//                                             <div className="mx-3 my-1" style={{ width: "29rem" }}>
//                                                 <label>{t("GST Number :")}</label>
//                                                 <input type="text" id="GST_No" placeholder={t("Enter GST No.")} className="form-control" required onChange={(e) => { setdata(e); checkGSTandPAN() }} style={{}} value={forminf.GST_No || ""} minLength={15} maxLength={15} />
//                                                 {isGSTValid === false && <b style={{ color: "red" }}>{t("Incorrect GST")}</b>}
//                                                 {isGSTValid === true && <b style={{ color: "green" }}>{t("Correct")}</b>}
//                                             </div>
//                                             <div className="mx-3 my-1" style={{ width: "29rem" }}>
//                                                 <label>{t("Aadhar Number :")}</label>
//                                                 <input type="text" id="AadharNo" placeholder={t("Enter Aadhar No.")} className="form-control" required onChange={(e) => { setdata(e); checkGSTandPAN() }} style={{}} value={forminf.AadharNo || ""} minLength={12} maxLength={12} />
//                                             </div>
//                                         </div>

//                                     </div>
//                                 </div>
//                                 <div className="mx-5" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}><h5 style={{ background: 'linear-gradient(to bottom, #3b409e, #0067ab, #0f79ba, #0098d5)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontWeight: '700', margin: '0px' }}><b>{t("Bank Details")}</b></h5></div>
//                                 <div style={{ display: 'flex', justifyContent: 'center', padding: '1rem 2rem 0px 2rem' }}>
//                                     <div style={{ backgroundColor: '#f4f7fe', borderRadius: '20px', paddingBottom: '15px' }}>
//                                         <div className="bidder_register_form">
//                                             <div className="mx-3 my-1" style={{ width: "29rem" }}>
//                                                 <label>{t("IFSC Code*:")}</label>
//                                                 <input type="text" id="IFSC_CODE" placeholder={t("Enter IFSC Code")} className="form-control" required onChange={(e) => { setdata(e); validateIfsc() }} style={{ textTransform: 'uppercase' }} />
//                                                 {
//                                                     isIfscValid !== null && (
//                                                         <b style={{ color: isIfscValid === false ? 'red' : 'green' }}>{isIfscValid === false ? t("IFSC Code is invalid") : t("IFSC code is valid")}</b>
//                                                     )
//                                                 }
//                                             </div>
//                                             <div className="mx-3 my-1" style={{ width: "29rem" }}>
//                                                 <label>{t("MICR Code :")}</label>
//                                                 <input type="text" id="MICRCode" placeholder={t("Enter MICR Code")} className="form-control" required onChange={(e) => { setdata(e) }} />
//                                                 {/* {formErrors.BranchName && (<small style={{ color: "red", fontWeight: "bold" }}>{formErrors.BranchName}</small>)} */}
//                                             </div>
//                                         </div>
//                                         <div className="bidder_register_form">
//                                             <div className="mx-3 my-1" style={{ width: "29rem" }}>
//                                                 <label>{t("Bank Name*:")}</label>
//                                                 <input type="text" id="BANK_NAME" placeholder={t("Enter Bank Name")} className="form-control" required onChange={(e) => { setdata(e) }} />
//                                                 {formErrors.BANK_NAME && (<small style={{ color: "red", fontWeight: "bold" }}>{formErrors.BANK_NAME}</small>)}
//                                             </div>
//                                             <div className="mx-3 my-1" style={{ width: "29rem" }}>
//                                                 <label>{t("Branch Name*:")}</label>
//                                                 <input type="text" id="BranchName" placeholder={t("Branch Name")} className="form-control" required onChange={(e) => { setdata(e) }} />
//                                                 {formErrors.BranchName && (<small style={{ color: "red", fontWeight: "bold" }}>{formErrors.BranchName}</small>)}
//                                             </div>
//                                             {/* <div className="mx-3 my-1" style={{ width: "29rem" }}>
//                                             <label>Account Holder Name*:</label>
//                                             <input type="text" id="Account_HolderName" placeholder="Enter Account Holder Name" className="form-control" required onChange={(e) => { setdata(e) }} />
//                                             {formErrors.Account_HolderName && (<small style={{ color: "red", fontWeight: "bold" }}>{formErrors.Account_HolderName}</small>)}
//                                         </div> */}
//                                         </div>
//                                         <div className="bidder_register_form">
//                                             <div className="mx-3 my-1" style={{ width: "29rem" }}>
//                                                 <label>{t("Account Number*:")}</label>
//                                                 <input type="text" id='checkacnumber' placeholder={t("Enter Account Number")} className="form-control" required onChange={(e) => { setdata(e) }} />
//                                                 {formErrors.checkacnumber && (<small style={{ color: "red", fontWeight: "bold" }}>{formErrors.checkacnumber}</small>)}
//                                             </div>
//                                             <div className="mx-3 my-1" style={{ width: "29rem" }}>
//                                                 <label>{t("Confirm Account Number*:")}</label>
//                                                 <input type="text" id="Account_Number" placeholder={t("Confirm Account Number")} className="form-control" required onChange={(e) => { setdata(e) }} />
//                                                 {
//                                                     accountnum !== null && (
//                                                         <b style={{ color: accountnum === false ? 'red' : 'green' }}>{accountnum === false ? 'Account number does not match' : 'Matched'}</b>
//                                                     )
//                                                 }
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="mx-5" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}><h5 style={{ background: 'linear-gradient(to bottom, #3b409e, #0067ab, #0f79ba, #0098d5)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontWeight: '700', margin: '0px' }}><b>Documents</b></h5></div>
//                                 <div style={{ display: 'flex', justifyContent: 'center', padding: '1rem 2rem 0px 2rem' }}>
//                                     <div style={{ backgroundColor: '#f4f7fe', borderRadius: '20px', paddingBottom: '15px' }}>
//                                         <div className="bidder_register_form">
//                                             <div className="mx-3 my-1" style={{ width: "29rem" }}>
//                                                 <label>{t("Passbok Upload :")}</label>
//                                                 <input type="file" id='PassbookDoc' className="form-control" required />
//                                             </div>
//                                             <div className="mx-3 my-1" style={{ width: "29rem" }}>
//                                                 <label>{t("Cheque Upload :")}</label>
//                                                 <input type="file" id="ChequeDoc" className="form-control" required />
//                                             </div>
//                                         </div>
//                                         <div className="bidder_register_form">
//                                             <div className="mx-3 my-1" style={{ width: "29rem" }}>
//                                                 <label>{t("Pan Upload :")}</label>
//                                                 <input type="file" id='PanDoc' className="form-control" required />
//                                             </div>
//                                             <div className="mx-3 my-1" style={{ width: "29rem" }}>
//                                                 <label>{t("Tan Upload :")}</label>
//                                                 <input type="file" id="TanDoc" className="form-control" required />
//                                             </div>
//                                         </div>
//                                         <div className="bidder_register_form">
//                                             <div className="mx-3 my-1" style={{ width: "29rem" }}>
//                                                 <label>{t("GST Upload :")}</label>
//                                                 <input type="file" id='GstDoc' className="form-control" required />
//                                             </div>
//                                             <div className="mx-3 my-1" style={{ width: "29rem" }}>
//                                                 <label>{t("Aadhaar Upload :")}</label>
//                                                 <input type="file" id="AadharDoc" className="form-control" required />
//                                             </div>
//                                         </div>

//                                     </div>
//                                 </div>

//                                 <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', padding: '2.5rem' }}>
//                                     <button type="submit" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', border: 'none', fontSize: '17px', gap: '4px' }}><img src={submit} style={{ width: '1.2rem', paddingBottom: '3px', fontSize: '15px' }} />{t("Submit")} </button>
//                                     <button onClick={resetData} type='button' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", backgroundColor: 'red', border: 'none', fontSize: '17px', gap: '4px' }}><img src={Cancel32} style={{ width: '1.2rem', }} /> {t("Cancel")}</button>
//                                     <Link to={'/Dashboard/DownloadReciept/' + forminf.Tender_ID + '/' + forminf.GST_No + '/' + forminf.PAN_No} hidden={recieptview} >{t("Download Reciept")}</Link>
//                                 </div>
//                             </Form>
//                         </div>
//                     </div>

//                 </div>
//             </div>
//         </>
//     );
// };

// export default CreateContractor;

import React, { useState, useContext, useEffect, useRef } from "react";
import "../../../../Users/homepage.css";
import "../../../../Users/pages/innercss.css";
import { Form, Link, redirect } from "react-router-dom";
import { useParams } from "react-router-dom";
import { apiurl } from "../../../../../path";
import UserApplication from "../../../../Users/UserContext/UserContext";
import {
  Bank32,
  barely_black_bg_img,
  Cancel32,
  Email32,
  Location32,
  PhoneNumber32,
  submit,
} from "../../../../../public/LoginImages/importimages";
import { useLanguage } from "../../../../../lang/langcontext/LanguageContext";
import * as exifr from "exifr";
import validateFile from "../../../../../utils/fileUploadHelper";

const CreateContractor = () => {
  const { language, toggleLanguage, t } = useLanguage();
  let data = useContext(UserApplication);
  const {
    SetNotification,
    paymentdata,
    GetAuctionsList,
    TenderRegisterHash,
    TenderPayment,
    DownloadReciept,
    setpaymentdata,
  } = data;
  const [form, setform] = useState([]);
  const [Auction, SetAuction] = useState([]);
  const { Auction_ID, Auction_Name } = useParams();
  const [loading, setLoading] = useState(false);

  const [forminf, SetForminf] = useState({
    Bidder_CompanyName: "",
    Address: "",
    City: "",
    PinCode: "",
    GST_No: "",
    PAN_No: "",
    TAN_No: "",
    AadharNo: "",
    Mobile_No: "",
    Email: "",
    Tender_ID: "",
    Tender_Name: "",
    TenderFee: "",
    ErnestMoneyDeposit: "",
    GST: "",
    Account_Number: "",
    IFSC_CODE: "",
    BANK_NAME: "",
    MICRNo: "",
    BranchName: "",
  });

  const [formErrors, setFormErrors] = useState({
    Bidder_CompanyName: "",
    Address: "",
    City: "",
    PinCode: "",
    GST_No: "",
    PAN_No: "",
    TAN_No: "",
    AadharNo: "",
    Mobile_No: "",
    Email: "",
    Tender_ID: "",
    Tender_Name: "",
    TenderFee: "",
    ErnestMoneyDeposit: "",
    GST: "",
    Account_Number: "",
    IFSC_CODE: "",
    BANK_NAME: "",
    MICRNo: "",
    BranchName: "",
  });

  console.log("Form Data:", forminf);

  const [recieptview, showrecieptview] = useState(true);
  const [isGSTValid, setIsGSTValid] = useState(null);
  const [isPANValid, setIsPANValid] = useState(null);
  const [isTANValid, setIsTANValid] = useState(null);
  const [accountnum, setaccountnum] = useState(null); // Used to check if account numbers match

  const [isIfscValid, setIsIfscValid] = useState(null);
  const [files, setFiles] = useState({});
  const formdataref = useRef(null);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const validation = validateFile(file, 2);
 
    if (!validation.valid) {
      alert(validation.message);
      e.target.value = "";
      return;
    }
    const cleanedFileName = file.name
      .trim()
      .replace(/\s+/g, "")
      .replace(/%/g, "_");

    const cleanedFile = new File([file], cleanedFileName, {
      type: file.type,
      lastModified: file.lastModified,
    });

    // store cleaned file using input name
    setFiles((prev) => ({
      ...prev,
      [e.target.id]: cleanedFile,
    }));
  };

  const validateIfsc = async () => {
    let IFSC_CODE = document.getElementById("IFSC_CODE").value.toUpperCase();
    if (IFSC_CODE.length !== 11) {
      return setIsIfscValid(false);
    }
    try {
      const response = await fetch(`https://ifsc.razorpay.com/${IFSC_CODE}`);
      if (response.ok) {
        const data = await response.json();
        console.log("bank details data", data);
        //  setIsIfscValid(true);
        SetForminf((prev) => ({
          ...prev,
          BANK_NAME: data.BANK,
          BranchName: data.BRANCH,
          MICRNo: data.MICR,
        }));
        setIsIfscValid(true);
        //  setIfscMessage("Valid IFSC Code");
      } else {
        setIsIfscValid(false);
      }
    } catch (error) {
      setIsIfscValid(false);
      console.error("Error validating IFSC code:", error);
    }
  };

  const checkGSTandPAN = (id, inputValue) => {
    // Standard PAN format (mandatory)
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
    const gstRegexFlexible =
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9A-Z]{1}[0-9A-Z]{1}[0-9A-Z]?$/;
    const tanRegex = /^[A-Z]{4}[0-9]{5}[A-Z]{1}$/; // Typical TAN format

    let PAN_Number = document.getElementById("PAN_No")?.value.toUpperCase();
    let Gst_Number = document.getElementById("GST_No")?.value.toUpperCase();
    let Tan_Number = document.getElementById("TAN_No")?.value.toUpperCase();

    if (id === "PAN_No") {
      setIsPANValid(
        inputValue.trim() === ""
          ? null
          : panRegex.test(inputValue.toUpperCase()),
      );
    }

    if (id === "TAN_No") {
      setIsTANValid(
        inputValue.trim() === ""
          ? null
          : tanRegex.test(inputValue.toUpperCase()),
      );
    }

    if (id === "GST_No") {
      // 1. If GST is empty, reset state and exit
      if (inputValue.trim() === "") {
        return setIsGSTValid(null);
      }

      // 2. Check Format (for 14 or 15 characters)
      if (
        !gstRegexFlexible.test(Gst_Number) ||
        Gst_Number.length < 14 ||
        Gst_Number.length > 15
      ) {
        return setIsGSTValid(false);
      }

      // 3. Check PAN Correlation
      if (!PAN_Number || !panRegex.test(PAN_Number)) {
        return setIsGSTValid(false);
      }

      // Extract the PAN part from the GSTIN (characters 3 to 12)
      const panInGST = Gst_Number.slice(2, 12);

      if (panInGST !== PAN_Number) {
        return setIsGSTValid(false);
      } else {
        // Passed both format check and PAN correlation
        setIsGSTValid(true);
      }
    }
  };

  useEffect(() => {
    try {
      setpaymentdata(null);
      // getdata()
    } catch (error) {
      console.error("Error in useEffect:", error);
      throw error;
    }
  }, []);

  const setdata = (e) => {
    const { id, value } = e.target;
    try {
      // Account Number Match Check (Handles input for both fields)
      let check = document.getElementById("checkacnumber")?.value;
      let acnum = document.getElementById("Account_Number")?.value;
      if (id === "BANK_NAME" || id === "BranchName") {
        return;
      }
      if (check === "" || acnum === "") {
        setaccountnum(null);
      } else {
        setaccountnum(check === acnum ? true : false);
      }

      let finalValue = value;
      let errorMessage = "";

      const validName = /^[a-zA-Z .'-]*$/;

      const validAddress = /^[a-zA-Z0-9 ,.\/#-]*$/;

      const validPinCode = /^[0-9]{6}$/;
      const validMobile = /^[0-9]{10}$/;
      const validEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const validAccountNumber = /^[0-9]{6,18}$/;

      // Fields that must NOT contain numbers
      // if (id === "Bidder_CompanyName" || id === "City") {
      //   if (!validName.test(value)) {
      //     errorMessage =
      //       "Only letters, spaces, and basic punctuation (., ', -) are allowed. Numbers are not permitted.";
      //   }
      // }

      // Field that must allow numbers (Address)
      if (id === "Address") {
        if (!validAddress.test(value)) {
          errorMessage =
            "Only letters, numbers, spaces, and common address symbols are allowed for the Address.";
        }
      }

      if (id === "PinCode") {
        if (value === "") {
          errorMessage = "";
        } else if (!validPinCode.test(value)) {
          errorMessage = "Pin code must be exactly 6 digits.";
        } else {
          errorMessage = "";
        }
      }
      // Ensure IFSC_CODE is always uppercase
      if (
        id === "IFSC_CODE" ||
        id === "PAN_No" ||
        id === "TAN_No" ||
        id === "GST_No"
      ) {
        finalValue = value.toUpperCase();
      }

      if (id === "MobileNumber" && !validMobile.test(value)) {
        errorMessage = "Mobile number must be exactly 10 digits.";
      }

      if (id === "Email") {
        if (value === "") {
          errorMessage = "";
        } else if (!validEmail.test(value)) {
          errorMessage = "Invalid email format. Example: abc@example.com.";
        } else {
          errorMessage = "";
        }
      }

      if (id === "checkacnumber" || id === "Account_Number") {
        if (value === "") {
          errorMessage = "";
        } else if (!validAccountNumber.test(value)) {
          errorMessage = "Account number must be 6 to 18 digits.";
        } else {
          errorMessage = "";
        }
      }

      // Update form state
      SetForminf((prev) => ({ ...prev, [id]: finalValue }));
      setFormErrors((prev) => ({ ...prev, [id]: errorMessage }));
      // Perform validation only for GST_No, PAN_No, and TAN_No
      if (id === "GST_No" || id === "PAN_No" || id === "TAN_No") {
        checkGSTandPAN(id, finalValue);
      }
      // Re-check GST validity immediately after PAN changes
      if (id === "PAN_No" && forminf.GST_No) {
        checkGSTandPAN("GST_No", forminf.GST_No);
      }
    } catch (error) {
      console.error("Error in setdata:", error);
    }
  };

  var upload = new FormData();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // 1. Check Mandatory Fields (Except GST/TAN)
    const mandatoryFields = [
      { key: "Bidder_CompanyName", name: "Vendor Name" },
      // { key: 'Address', name: 'Address' },
      { key: "City", name: "City" },
      { key: "PinCode", name: "Pin Code" },
      // { key: 'AadharNo', name: 'Aadhar Number' },
      { key: "Mobile_No", name: "Mobile No" },
      // { key: 'Email', name: 'Email' },
      { key: 'PAN_No', name: 'PAN Number' },
      { key: "IFSC_CODE", name: "IFSC Code" },
      { key: "BANK_NAME", name: "Bank Name" },
      { key: "MICRNo", name: "MICR Code" },
      { key: "BranchName", name: "Branch Name" },
    ];

    let missingFields = [];
    // mandatoryFields.forEach(field => {
    //     // Check based on the state or the input element's value
    //     if (!forminf[field.key] || String(forminf[field.key]).trim() === '') {
    //         missingFields.push(field.name);
    //     }
    // });

    // Manual check for the two separate Account Number fields
    if (
      !document.getElementById("checkacnumber").value ||
      document.getElementById("checkacnumber").value.trim() === ""
    ) {
      missingFields.push("Account Number");
    }
    if (
      !document.getElementById("Account_Number").value ||
      document.getElementById("Account_Number").value.trim() === ""
    ) {
      missingFields.push("Confirm Account Number");
    }

    if (missingFields.length > 0) {
      alert(
        "Please fill all mandatory fields:\n- " + missingFields.join("\n- "),
      );
      setLoading(false);
      return;
    }

    // 2. Check File Uploads (Existing logic - assuming file inputs are in the DOM)
    const requiredFiles = ["PassbookDoc", "ChequeDoc"]; // PAN/AADHAAR/GST/TAN are optional
    let missingFiles = [];

    // requiredFiles.forEach(fileId => {
    //     const fileInput = document.getElementById(fileId);
    //     if (!fileInput || fileInput.files.length === 0) {
    //         missingFiles.push(fileId.replace('Doc', ' Document'));
    //     }
    // });

    // if (missingFiles.length > 0) {
    //     alert(`Please upload the following required documents:\n- ${missingFiles.join('\n- ')}`);
    //     setLoading(false);
    //     return;
    // }

    // 3. Check Validation States (Ensure correct details are entered)
    let validationAlerts = [];

    // Check Account Match (Uses the state variable set in setdata)
    if (accountnum !== true) {
      validationAlerts.push(
        "Account Number and Confirm Account Number must match.",
      );
    }

    // Check IFSC Validity (Uses the state variable set in validateIfsc)
    if (isIfscValid !== true) {
      validationAlerts.push("IFSC Code is invalid or not validated.");
    }

    // Check mandatory PAN Validity
    if (forminf.PAN_No && isPANValid !== true) {
      validationAlerts.push("PAN Number is invalid.");
    }

    // Check Name field validation errors
    if (
      formErrors.Bidder_CompanyName ||
      formErrors.City ||
      formErrors.BANK_NAME ||
      formErrors.BranchName
    ) {
      validationAlerts.push(
        "Name, City, Bank Name, or Branch Name contains invalid characters (e.g., numbers).",
      );
    }

    // Check optional fields only if they have a value
    // if (forminf.GST_No && isGSTValid !== true) {
    //   validationAlerts.push(
    //     "GST Number is incorrect (format or PAN mismatch).",
    //   );
    // }
    if (forminf.TAN_No && isTANValid !== true) {
      validationAlerts.push("TAN Number is invalid.");
    }

    if (validationAlerts.length > 0) {
      alert(
        "Please correct the following details before submitting:\n" +
          validationAlerts.join("\n"),
      );
      setLoading(false);
      return;
    }

    // Proceed with form submission logic
    let token = localStorage.getItem("Token");
    try {
      for (const key in forminf) {
        upload.append(key, forminf[key]);
      }

      // Append all files (required and optional)
      upload.append("PassbookDoc", files.PassbookDoc);
      upload.append("ChequeDoc", files.ChequeDoc);
      upload.append("PanDoc", files.PanDoc);
      upload.append("AadharDoc", files.AadharDoc);

      if (files.TanDoc) upload.append("TanDoc", files.TanDoc);
      if (files.GstDoc) upload.append("GstDoc", files.GstDoc);

      const response = await fetch(
        `${apiurl}/VendorManagement/ContractorRegistration`,
        {
          method: "POST",
          headers: { AuthToken: token },
          body: upload,
        },
      );
      const data = await response.json();
      console.log(data);
      if (data.message) {
        alert(data.message);
        window.location.reload();
      }
    } catch (error) {
      console.error("Error in onSubmit:", error);
    } finally {
      setLoading(false);
    }
  };
  const resetData = () => {
    formdataref.current.reset();
    SetForminf({}); // Use empty object instead of array
  };

  return (
    <>
      <div style={{ maxHeight: "91vh", overflowY: "auto" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "2.5rem",
            backgroundColor: "#ece9fe",
          }}
        >
          <h5 style={{ textAlign: "center" }}>
            <b>{t("Vendor Registration")}</b>
          </h5>
        </div>
        <div
          style={{
            backgroundColor: "#f4f7fe",
            backgroundSize: "cover",
            width: "82vw",
            alignSelf: "center",
            display: "grid",
            justifyContent: "center",
            padding: "1rem",
            position: "relative",
            backdropFilter: "blur(10px)",
          }}
        >
          <div style={{ display: "grid", justifyContent: "center" }}>
            <div className="card-body my-3" style={{ width: "75vw" }}>
              {loading && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(255, 255, 255, 0.7)",
                    backdropFilter: "blur(4px)",
                    zIndex: 9999,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      border: "6px solid #f3f3f3",
                      borderTop: "6px solid #007bff",
                      borderRadius: "50%",
                      width: "60px",
                      height: "60px",
                      animation: "spin 1s linear infinite",
                    }}
                  />
                  <style>
                    {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                  </style>
                </div>
              )}
              <Form
                id="form1"
                ref={formdataref}
                onSubmit={onSubmit}
                style={{
                  backgroundColor: "rgb(255,255,255,0.8)",
                  borderRadius: "20px 20px 0px 0px",
                }}
              >
                <div
                  className="mx-5"
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <h5
                    style={{
                      background:
                        "linear-gradient(to bottom, #3b409e, #0067ab, #0f79ba, #0098d5)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      fontWeight: "700",
                      margin: "0px",
                      paddingTop: "4px",
                    }}
                  >
                    <b>{t("Personal Details")}</b>
                  </h5>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "2rem",
                  }}
                >
                  <div
                    style={{
                      backgroundColor: "#f4f7fe",
                      borderRadius: "20px",
                      paddingBottom: "15px",
                    }}
                  >
                    <div className="bidder_register_form">
                      <div className="mx-3 my-1" style={{ width: "29rem" }}>
                        {/* Vendor Name - MANDATORY (No numbers allowed) */}
                        <label>
                          {t("Vendor Name")}{" "}
                          <span className="text-danger">*</span>:
                        </label>
                        <input
                          type="text"
                          id="Bidder_CompanyName"
                          placeholder={t("Enter Vendor Name")}
                          className="form-control"
                          onChange={(e) => {
                            setdata(e);
                          }}
                        />
                        {formErrors.Bidder_CompanyName && (
                          <small style={{ color: "red", fontWeight: "bold" }}>
                            {formErrors.Bidder_CompanyName}
                          </small>
                        )}
                      </div>
                      <div className="mx-3 my-1" style={{ width: "29rem" }}>
                        {/* Address - MANDATORY (Numbers allowed) */}
                        <label>
                          {t("Address")} <span className="text-danger">*</span>:
                        </label>
                        <div style={{ position: "relative" }}>
                          <input
                            type="text"
                            id="Address"
                            placeholder={t("Enter Address")}
                            className="form-control"
                            onChange={(e) => {
                              setdata(e);
                            }}
                          />
                          <img
                            src={Location32}
                            alt="Email Icon"
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              width: "20px",
                              height: "20px",
                            }}
                          />
                        </div>
                        {formErrors.Address && (
                          <small style={{ color: "red", fontWeight: "bold" }}>
                            {formErrors.Address}
                          </small>
                        )}
                      </div>
                    </div>
                    <div className="bidder_register_form">
                      <div className="mx-3 my-1" style={{ width: "29rem" }}>
                        {/* Mobile No - MANDATORY */}
                        <label>
                          {t("Mobile No")}{" "}
                          <span className="text-danger">*</span>:
                        </label>
                        <div style={{ position: "relative" }}>
                          <input
                            type="text"
                            className="form-control"
                            id="Mobile_No"
                            pattern="\d{10}"
                            minLength="10"
                            maxLength="10"
                            placeholder={t("Enter Mobile No")}
                            onInput={(e) => {
                              let enteredValue = e.target.value;
                              enteredValue = enteredValue
                                .slice(0, 10)
                                .replace(/\D/g, "");
                              e.target.value = enteredValue;
                            }}
                            onChange={(e) => {
                              setdata(e);
                            }}
                          />
                          <img
                            src={PhoneNumber32}
                            alt="Email Icon"
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              width: "20px",
                              height: "20px",
                            }}
                          />
                        </div>
                        {formErrors.MobileNumber && (
                          <small style={{ color: "red", fontWeight: "bold" }}>
                            {formErrors.MobileNumber}
                          </small>
                        )}
                      </div>
                      <div
                        className="mx-3 my-1"
                        style={{ width: "29rem", position: "relative" }}
                      >
                        {/* Email - MANDATORY */}
                        <label>{t("Email")} :</label>
                        <div style={{ position: "relative" }}>
                          <input
                            type="email"
                            id="Email"
                            placeholder={t("Enter Email")}
                            className="form-control pe-5"
                            onChange={(e) => setdata(e)}
                          />
                          <img
                            src={Email32}
                            alt="Email Icon"
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              width: "20px",
                              height: "20px",
                            }}
                          />
                        </div>
                        {formErrors.Email && (
                          <small style={{ color: "red", fontWeight: "bold" }}>
                            {formErrors.Email}
                          </small>
                        )}
                      </div>
                    </div>
                    <div className="bidder_register_form">
                      <div className="mx-3 my-1" style={{ width: "29rem" }}>
                        {/* Pin Code - MANDATORY */}
                        <label>
                          {t("Pin Code")} <span className="text-danger">*</span>
                          :
                        </label>
                        <input
                          type="tel"
                          id="PinCode"
                          pattern="\d{6}"
                          minLength="6"
                          maxLength="6"
                          placeholder={t("Enter Pin Code")}
                          className="form-control"
                          onInput={(e) => {
                            let enteredValue = e.target.value;
                            enteredValue = enteredValue
                              .slice(0, 6)
                              .replace(/\D/g, "");
                            e.target.value = enteredValue;
                          }}
                          onChange={(e) => {
                            setdata(e);
                          }}
                        />{" "}
                        {formErrors.PinCode && (
                          <small style={{ color: "red", fontWeight: "bold" }}>
                            {formErrors.PinCode}
                          </small>
                        )}
                      </div>
                      <div className="mx-3 my-1" style={{ width: "29rem" }}>
                        {/* City - MANDATORY (No numbers allowed) */}
                        <label>
                          {t("City")} <span className="text-danger">*</span>:
                        </label>
                        <input
                          type="text"
                          id="City"
                          placeholder={t("Enter City")}
                          className="form-control"
                          onChange={(e) => {
                            setdata(e);
                          }}
                        />
                        {formErrors.City && (
                          <small style={{ color: "red", fontWeight: "bold" }}>
                            {formErrors.City}
                          </small>
                        )}
                      </div>
                    </div>
                    <div className="bidder_register_form">
                      <div className="mx-3 my-1" style={{ width: "29rem" }}>
                        {/* PAN Number - MANDATORY */}
                        <label>{t("PAN Number")}<span className="text-danger">*</span>:</label>
                        <input
                          type="text"
                          id="PAN_No"
                          placeholder={t("Enter PAN Number")}
                          className="form-control"
                          onChange={(e) => {
                            setdata(e);
                          }}
                          style={{ textTransform: "uppercase" }}
                          value={forminf.PAN_No || ""}
                          minLength={10}
                          maxLength={10}
                        />
                        {isPANValid === false && (
                          <b style={{ color: "red" }}>{t("Invalid PAN")}</b>
                        )}
                        {isPANValid === true && (
                          <b style={{ color: "green" }}>{t("Valid")}</b>
                        )}
                      </div>
                      <div className="mx-3 my-1" style={{ width: "29rem" }}>
                        {/* TAN Number - OPTIONAL (No asterisk/required) */}
                        <label>{t("TAN Number")} :</label>
                        <input
                          type="text"
                          id="TAN_No"
                          placeholder={t("Enter TAN No.")}
                          className="form-control"
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value.length === 1 && value[0] === " ") return;
                            setdata(e);
                          }}
                          style={{ textTransform: "uppercase" }}
                          value={forminf.TAN_No || ""}
                          minLength={10}
                          maxLength={10}
                        />
                        {isTANValid === false && forminf.TAN_No.length > 0 && (
                          <b style={{ color: "red" }}>{t("Invalid TAN")}</b>
                        )}
                        {isTANValid === true && forminf.TAN_No.length > 0 && (
                          <b style={{ color: "green" }}>{t("Valid")}</b>
                        )}
                      </div>
                    </div>
                    <div className="bidder_register_form">
                      <div className="mx-3 my-1" style={{ width: "29rem" }}>
                        {/* GST Number - OPTIONAL (Max length 15, allowing 14 or 15 char inputs) */}
                        <label>{t("GST Number")} :</label>
                        <input
                          type="text"
                          id="GST_No"
                          placeholder={t("Enter GST No.")}
                          className="form-control"
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value.length === 1 && value[0] === " ") return;
                            setdata(e);
                          }}
                          style={{ textTransform: "uppercase" }}
                          value={forminf.GST_No || ""}
                          maxLength={15}
                        />
                        {/* {isGSTValid === false && forminf.GST_No.length > 0 && (
                          <b style={{ color: "red" }}>
                            {t("Incorrect GST (Check format and matching PAN)")}
                          </b>
                        )} */}
                        {isGSTValid === true && forminf.GST_No.length > 0 && (
                          <b style={{ color: "green" }}>{t("Correct")}</b>
                        )}
                      </div>
                      <div className="mx-3 my-1" style={{ width: "29rem" }}>
                        {/* Aadhar Number - MANDATORY */}
                        <label>{t("Aadhar Number")}<span className="text-danger">*</span>:</label>
                        <input
                          type="text"
                          id="AadharNo"
                          placeholder={t("Enter Aadhar No.")}
                          className="form-control"
                          onChange={(e) => {
                            let value = e.target.value.replace(/[^0-9]/g, "");
                            e.target.value = value;
                            setdata(e);
                          }}
                          style={{}}
                          value={forminf.AadharNo || ""}
                          minLength={12}
                          maxLength={12}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="mx-5"
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <h5
                    style={{
                      background:
                        "linear-gradient(to bottom, #3b409e, #0067ab, #0f79ba, #0098d5)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      fontWeight: "700",
                      margin: "0px",
                      paddingTop: "4px",
                    }}
                  >
                    <b>{t("Bank Details")}</b>
                  </h5>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "1rem 2rem 0px 2rem",
                  }}
                >
                  <div
                    style={{
                      backgroundColor: "#f4f7fe",
                      borderRadius: "20px",
                      paddingBottom: "15px",
                    }}
                  >
                    <div className="bidder_register_form">
                      <div className="mx-3 my-1" style={{ width: "29rem" }}>
                        {/* Account Number (checkacnumber) - MANDATORY */}
                        <label>
                          {t("Account Number")}{" "}
                          <span className="text-danger">*</span>:
                        </label>
                        <input
                          type="text"
                          id="checkacnumber"
                          placeholder={t("Enter Account Number")}
                          className="form-control"
                          onChange={(e) => {
                            let value = e.target.value.replace(/[^0-9]/g, "");
                            e.target.value = value;
                            setdata(e);
                          }}
                          minLength={6}
                          maxLength={18}
                        />
                        {formErrors.checkacnumber && (
                          <small style={{ color: "red", fontWeight: "bold" }}>
                            {formErrors.checkacnumber}
                          </small>
                        )}
                      </div>
                      <div className="mx-3 my-1" style={{ width: "29rem" }}>
                        {/* Confirm Account Number (Account_Number) - MANDATORY */}
                        <label>
                          {t("Confirm Account Number")}{" "}
                          <span className="text-danger">*</span>:
                        </label>
                        <input
                          type="text"
                          id="Account_Number"
                          placeholder={t("Confirm Account Number")}
                          className="form-control"
                          onChange={(e) => {
                            let value = e.target.value.replace(/[^0-9]/g, "");
                            e.target.value = value;
                            setdata(e);
                          }}
                          minLength={6}
                          maxLength={18}
                        />
                        {accountnum !== null && accountnum === false && (
                          <b style={{ color: "red" }}>
                            {t("Account Number Does not Match")}
                          </b>
                        )}
                        {accountnum === true && (
                          <b style={{ color: "green" }}>
                            {t("Account Number Match")}
                          </b>
                        )}
                      </div>
                    </div>
                    <div className="bidder_register_form">
                      <div className="mx-3 my-1" style={{ width: "29rem" }}>
                        {/* IFSC Code - MANDATORY */}
                        <label>
                          {t("IFSC Code")}{" "}
                          <span className="text-danger">*</span>:
                        </label>
                        <input
                          type="text"
                          id="IFSC_CODE"
                          placeholder={t("Enter IFSC Code")}
                          className="form-control"
                          onChange={(e) => {
                            setdata(e);
                            validateIfsc();
                          }}
                          style={{ textTransform: "uppercase" }}
                          minLength={11}
                          maxLength={11}
                        />
                        {isIfscValid !== null && (
                          <b
                            style={{
                              color: isIfscValid === false ? "red" : "green",
                            }}
                          >
                            {isIfscValid === false
                              ? t("IFSC Code is invalid")
                              : t("IFSC code is valid")}
                          </b>
                        )}
                      </div>
                      <div className="mx-3 my-1" style={{ width: "29rem" }}>
                        {/* MICR Code - MANDATORY */}
                        <label>
                          {t("MICR Code")}{" "}
                          <span className="text-danger">*</span>:
                        </label>
                        <input
                          type="text"
                          id="MICRNo"
                          placeholder={t("Enter MICR Code")}
                          className="form-control"
                          onChange={(e) => {
                            setdata(e);
                          }}
                          value={forminf.MICRNo}
                        />
                      </div>
                    </div>
                    <div className="bidder_register_form">
                      <div className="mx-3 my-1" style={{ width: "29rem" }}>
                        {/* Bank Name - MANDATORY (No numbers allowed) */}
                        <label>
                          {t("Bank Name")}{" "}
                          <span className="text-danger">*</span>:
                        </label>
                        <input
                          type="text"
                          id="BANK_NAME"
                          placeholder={t("Enter Bank Name")}
                          className="form-control"
                          onChange={(e) => {
                            setdata(e);
                          }}
                          value={forminf.BANK_NAME}
                        />
                        {formErrors.BANK_NAME && (
                          <small style={{ color: "red", fontWeight: "bold" }}>
                            {formErrors.BANK_NAME}
                          </small>
                        )}
                      </div>
                      <div className="mx-3 my-1" style={{ width: "29rem" }}>
                        {/* Branch Name - MANDATORY (No numbers allowed) */}
                        <label>
                          {t("Branch Name")}{" "}
                          <span className="text-danger">*</span>:
                        </label>
                        <input
                          type="text"
                          id="BranchName"
                          placeholder={t("Enter Branch Name")}
                          className="form-control"
                          onChange={(e) => {
                            setdata(e);
                          }}
                          value={forminf.BranchName}
                        />
                        {formErrors.BranchName && (
                          <small style={{ color: "red", fontWeight: "bold" }}>
                            {formErrors.BranchName}
                          </small>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* File Uploads Section (Ensure required attribute is used for file inputs) */}
                <div
                  className="mx-5"
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <h5
                    style={{
                      background:
                        "linear-gradient(to bottom, #3b409e, #0067ab, #0f79ba, #0098d5)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      fontWeight: "700",
                      margin: "0px",
                      paddingTop: "4px",
                    }}
                  >
                    <b>{t("Documents Upload")}</b>
                  </h5>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "1rem 2rem 0px 2rem",
                  }}
                >
                  <div
                    style={{
                      backgroundColor: "#f4f7fe",
                      borderRadius: "20px",
                      paddingBottom: "15px",
                    }}
                  >
                    <div className="bidder_register_form">
                      <div className="mx-3 my-1" style={{ width: "29rem" }}>
                        <label>
                          {t("Passbook Upload")}{" "}
                          <span className="text-danger">*</span>:
                        </label>
                        <input
                          type="file"
                          id="PassbookDoc"
                          className="form-control"
                          accept=".pdf,image/jpeg,image/png"
                          onChange={handleFileUpload}
                        />
                      </div>
                      <div className="mx-3 my-1" style={{ width: "29rem" }}>
                        <label>
                          {t("Cheque Upload")}{" "}
                          <span className="text-danger">*</span>:
                        </label>
                        <input
                          type="file"
                          id="ChequeDoc"
                          className="form-control"
                          accept=".pdf,image/jpeg,image/png"
                          onChange={handleFileUpload}
                        />
                      </div>
                    </div>
                    <div className="bidder_register_form">
                      <div className="mx-3 my-1" style={{ width: "29rem" }}>
                        <label>{t("Pan Upload")}<span className="text-danger">*</span>:</label>
                        <input
                          type="file"
                          id="PanDoc"
                          className="form-control"
                          accept=".pdf,image/jpeg,image/png"
                          onChange={handleFileUpload}
                          required
                        />
                      </div>
                      <div className="mx-3 my-1" style={{ width: "29rem" }}>
                        <label>{t("Tan Upload")} :</label>
                        <input
                          type="file"
                          id="TanDoc"
                          className="form-control"
                          accept=".pdf,image/jpeg,image/png"
                          onChange={handleFileUpload}
                        />
                      </div>
                    </div>
                    <div className="bidder_register_form">
                      <div className="mx-3 my-1" style={{ width: "29rem" }}>
                        <label>{t("GST Upload")} :</label>
                        <input
                          type="file"
                          id="GstDoc"
                          className="form-control"
                          accept=".pdf,image/jpeg,image/png"
                          onChange={handleFileUpload}
                        />
                      </div>
                      <div className="mx-3 my-1" style={{ width: "29rem" }}>
                        <label>{t("Aadhar Upload")}<span className="text-danger">*</span>:</label>
                        <input
                          type="file"
                          id="AadharDoc"
                          className="form-control"
                          accept=".pdf,image/jpeg,image/png"
                          onChange={handleFileUpload}
                          // required
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* Submit Buttons */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "10px",
                    padding: "2.5rem",
                  }}
                >
                  <button
                    type="submit"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "20px",
                      width: "8rem",
                      height: "2.5rem",
                      background:
                        "linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )",
                      border: "none",
                      fontSize: "17px",
                      gap: "4px",
                    }}
                  >
                    <img
                      src={submit}
                      style={{
                        width: "1.2rem",
                        paddingBottom: "3px",
                        fontSize: "15px",
                      }}
                    />
                    {t("Submit")}{" "}
                  </button>
                  <button
                    onClick={resetData}
                    type="button"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "20px",
                      width: "7rem",
                      height: "2.5rem",
                      backgroundColor: "red",
                      border: "none",
                      fontSize: "16px",
                      gap: "4px",
                      paddingTop: "3px",
                    }}
                  >
                    <img src={Cancel32} style={{ width: "1.2rem" }} />{" "}
                    {t("Cancel")}
                  </button>
                  <Link
                    to={
                      "/Dashboard/DownloadReciept/" +
                      forminf.Tender_ID +
                      "/" +
                      forminf.GST_No +
                      "/" +
                      forminf.PAN_No
                    }
                    hidden={recieptview}
                  >
                    {t("Download Reciept")}
                  </Link>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateContractor;
